import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { HelpCircle, X } from "lucide-react";

let seenCache = null;
async function loadSeen() {
  if (seenCache) return seenCache;
  try { const { data } = await api.get("/tutorial"); seenCache = data.tips_seen || []; } catch { seenCache = []; }
  return seenCache;
}

export function Tip({ id, text, helpLink, helpLabel }) {
  const [open, setOpen] = useState(false);
  const [auto, setAuto] = useState(false);
  const navigate = useNavigate();
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) close(); };
    document.addEventListener("pointerdown", onDown);
    return () => document.removeEventListener("pointerdown", onDown);
  }); // eslint-disable-line
  useEffect(() => { loadSeen().then((seen) => { if (!seen.includes(id)) { setOpen(true); setAuto(true); } }); }, [id]);
  const close = async () => { setOpen(false); if (auto) { seenCache = [...(seenCache || []), id]; api.post(`/tips/${id}/seen`).catch(() => {}); setAuto(false); } };
  return (
    <span className="relative inline-flex" ref={ref}>
      <button type="button" onClick={() => (open ? close() : setOpen(true))} className="grid h-6 w-6 place-items-center rounded-full border border-slate-700 text-slate-400 hover:border-cyan-400 hover:text-cyan-300" title="Dica" data-testid={`tip-${id}`}><HelpCircle className="h-3.5 w-3.5" /></button>
      {open && (
        <span className="animate-flow-in absolute left-0 top-8 z-30 w-72 rounded-xl border border-cyan-400/30 bg-slate-950/95 p-3 text-xs text-slate-200 shadow-xl backdrop-blur" data-testid={`tip-popover-${id}`}>
          <button type="button" onClick={close} className="absolute right-2 top-2 text-slate-500 hover:text-slate-200" data-testid={`tip-close-${id}`}><X className="h-3.5 w-3.5" /></button>
          <span className="block pr-5 leading-relaxed">{text}</span>
          {helpLink && <button type="button" onClick={() => { close(); navigate(helpLink); }} className="mt-2 block text-cyan-300 hover:underline" data-testid={`tip-help-${id}`}>{helpLabel || "Como fazer?"}</button>}
        </span>
      )}
    </span>
  );
}
